
<div class="content-calendar" *ngIf="isCalendarEvents" [class.active]="selectedIndex === indexCalendar">
    <button (click)="addToCalendar(indexCalendar)">{{calendarButtonName}}</button>
</div>
